export enum SessionState {
  Ready = 'READY',
  Running = 'RUNNING',
  Done = 'DONE',
}

export default interface Session {
  id: number;
  state: SessionState;
}